import { render, staticRenderFns } from "./DeputyCreateDialog.vue?vue&type=template&id=0a2295d6&scoped=true"
import script from "./DeputyCreateDialog.vue?vue&type=script&lang=js"
export * from "./DeputyCreateDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2295d6",
  null
  
)

export default component.exports